import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TimeoutError } from 'rxjs';
import { TimeoutErrorHandler } from 'src/shared/providers/http/timeout-error-handler';
import { CommonUtils } from 'src/shared/utils/common-utils';

@Component({
    selector: 'confirm-page',
    templateUrl: './confirm.html',
    standalone: false
})
export class ConfirmPage {

  @Input() title: string;
  @Input() body: string;
  @Input() backText: string;
  @Input() confirmText: string;
  @Input() confirmAction: (data?) => Promise<any>;
  @Input() confirmActionParams: any = null;
  @Input() customBackAction: (data?) => Promise<any>;
  @Input() customBackParams: any = null;
  @Input() sameRowButtons = true;
  @Input() confirmButtonClass = 'primary';
  @Input() backButtonClass = 'secondary';
  errorMessage = '';

  constructor(
    private modalCtrl: ModalController,
    private timeoutErrorHandler: TimeoutErrorHandler,
    private utils: CommonUtils
  ) {
  }

  backAction = async () => {
    if (this.customBackAction) {
      try {
        await this.customBackAction(this.customBackParams);
      } catch (err) {
        this.timeoutHandler(err);
        this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
        this.utils.showError(this.errorMessage);
      }
    } else {
      this.modalCtrl.dismiss();
    }
  }

  confirm = async () => {
    try {
      await this.confirmAction(this.confirmActionParams);
    } catch (err) {
      this.timeoutHandler(err);
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      this.utils.showError(this.errorMessage);
    }
  }

  timeoutHandler(error) {
    if (error instanceof TimeoutError) {
      this.title = this.timeoutErrorHandler.timeoutParams.header;
      this.body = this.timeoutErrorHandler.timeoutParams.body;
      this.confirmText = this.timeoutErrorHandler.timeoutParams.buttonText;
      throw error.message;
    }
  }
}

export interface ConfirmPageParamsModel {
  title: string;
  body: string;
  backText: string;
  confirmText: string;
  confirmAction: (data?) => Promise<any>;
  confirmActionParams?: any;
  customBackAction?: (data?) => Promise<any>;
  customBackParams?: any;
  sameRowButtons?: boolean;
  confirmButtonClass?: string;
  backButtonClass?: string;
}
